export const extractLocaleFromUrl = (location: { pathname: string }, defaultLocale?: string) => {
  const pathName = location.pathname
  const match = pathName.match(/^\/([a-z]{2})(\/|$)/)

  return match ? match[0].replace(/\//g, '') : defaultLocale || undefined
}
